import * as d3 from 'd3'
export default {
  methods: {

    gmx_openWindow(selection, props, reverse=null) {
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(75).attr('opacity', reverse ? 1 : .4)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(250).attr('opacity', reverse ? .4 : 1)
      })
      .on('click', () => {
        this.winProps = props
        this.gmx_drawWindow() // -----> below
      })
    },


    gmx_drawWindow() {

      let winX = (this.Canvas.CanvasWidth - this.winProps.width) / 2
      let winY = (this.Canvas.CanvasHeight - this.winProps.height) / 2 - 100

      this.canvasWindow = this.svg
      .append('g')
      .attr('transform', `translate(0, 0)`)
      .style('font-family', 'roboto').attr('cursor', 'default').attr('opacity', 1)

      this.canvasWindow
      .append('rect')
      .attr('width', this.Canvas.CanvasWidth).attr('height', this.Canvas.CanvasHeight).attr('fill', '#fff').attr('opacity', .8)

      let popupGroup = this.canvasWindow
      .append('g')
      .attr('transform', `translate(${winX}, ${winY})`)
      .style('font-family', 'roboto').attr('cursor', 'default')

      popupGroup
      .append('rect')
      .attr('rx', 10).attr('ry', 10)
      .attr('width', this.winProps.width).attr('height', this.winProps.height)
      .attr('fill', '#fff').attr('stroke', '#000').attr('stroke-width', .5).attr('stroke', 1)
      .attr('filter', 'url(#dropShadow)').style('opacity', .5)

      popupGroup
      .append('rect')
      .attr('rx', 10).attr('ry', 10)
      .attr('width', this.winProps.width).attr('height', 50).attr('fill', `url(#${this.localId}_LightBlue_H2)`)

      popupGroup
      .append('image') // Close Icon
      .attr('xlink:href', this.HOST + `/Database/icon/Close.svg`)
      .attr('x', this.winProps.width-30).attr('y', 10).attr('width', 18).attr('opacity', .8).attr('cursor', 'pointer')
      .on('mouseover', function() {d3.select(this).attr('opacity', .4)})
      .on('mouseout', function() {d3.select(this).attr('opacity', .8)})
      .on('click', () => {
       this.close_Window()
      })

      popupGroup
      .append('rect')
      .attr('y', 40).attr('fill', '#fff').attr('width', this.winProps.width).attr('height', this.winProps.height-55)

      this.winProps.exeFunc(popupGroup) // -----> functional
    },


    call_WinClosed(selection) {
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(75).style('opacity', .5)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(250).style('opacity', 1)
      })
      .on('click', () => {
        this.close_Window() // -----> below
      })
    },


    close_Window() {
      this.canvasWindow.transition().duration(500).attr('opacity', 0)
      setTimeout(() => {
        this.canvasWindow.remove() // -----> Popup.js
        this.winProps = {status: 'closed', width: this.Canvas.CanvasWidth, height: this.Canvas.CanvasHeight,}
      }, 500)
    },


  }
}